import { createContext, useMemo, useContext, useState, useEffect, useRef, useCallback } from 'react';
import Cookies from 'universal-cookie';
import { useGeneral } from '../../Context/GeneralContext';

const InfoCeldasContext = createContext();

export function InfoCeldasProvider(props) {
    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const { celda, tokenR } = useGeneral();
    const [orders, setOrders] = useState([]);
    const [porEfi, setPorEfi] = useState('');
    const [porUti, setPorUti] = useState('');
    const [mttr, setMttr] = useState('');
    const [mtbf, setMtbf] = useState('');
    const [intervalo, setIntervalo] = useState(0);
    const [cant, setCant] = useState(0);
    const [estatus, setEstatus] = useState([]);
    const [startCorrida, setStartCorrida] = useState(true);
    const [isCorridaActive, setIsCorridaActive] = useState(0);
    const [status, setStatus] = useState('');
    const [detailOrder, setDetailOrder] = useState({
        nombre: '',
        corrida: null,
        sku: '',
        fechaIni: '',
        fechaFin: '',
    });
    const [detailCorrida, setDetailCorrida] = useState({
        conteo: 0,
        corrida: 0,
        fechaFinReal: '',
        fechaIniReal: '',
        operador: '',
        piezasMalas: 0,
        producido: 0,
    });

    let interval;

    const meses = useMemo(() => ([
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ]), []);

    const dias = useMemo(() => (['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']), []);

    const getOrders = useCallback( async () => {
        const cookie = new Cookies();
        const linea = cookie.get('linea');
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/PisoOrdenes/GetOrdenes?linea=${linea}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const ordenes = await data.json();

        if (data.status !== 400) {
            setOrders(ordenes);
        }
    },[tokenSessionObject.token]);

    const getCorrida = useCallback(async (idCorrida, utoken) => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/PisoOrdenes/GetCorrida?corrida=${idCorrida}&celda=${celda}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${utoken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
    
        const corrida = await data.json();
    
        if (data.status !== 400) {
            setDetailCorrida(corrida[0]);
    
            const order = orders.find((order) => order.corrida === corrida[0].corrida);
            if (order) {
                setDetailOrder(order);
            }
        }
    }, [celda, orders]); 
    
    const getEfiyUti = useCallback(async (utoken) => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Informes/GetEficienciaUtilizacion?celda=${celda}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${utoken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
    
        const values = await data.json();
    
        if (data.status !== 400) {
            setPorEfi(values.eficiencia);
            setPorUti(values.porcentajeUtilizacion);
            setMtbf(values.mtbf);
            setMttr(values.mttr);
        }
    }, [celda]);  

    const getEstyCont = useCallback(async (utoken) => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/Informes/GetConteoCorrida?celda=${celda}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${utoken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
    
        const values = await data.json();
    
        if (data.status !== 400) {
            setCant(values.planeado);
    
            const est = estatus.find((est) => est.codigo === values.estatus);
            if (est) {
                setStatus(est);
            }
        }
    }, [celda, estatus]);
    

    const getCorridaActiva = useCallback( async (utoken) => {
        const cookie = new Cookies();

        const data = await fetch(
            `${
                process.env.REACT_APP_SERVICE_ENDPOINT_NE
            }/PisoOrdenes/GetCorridaActiva?linea=${parseInt(cookie.get('linea'))}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${utoken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const corridaA = await data.json();
        if (data.status === 200) {
            setIsCorridaActive(true);
            setStartCorrida(true);
            if (intervalo === 0) {
                getEfiyUti(utoken);
            } else {
                getEfiyUtiFecha(utoken);
            }
            getEstyCont(utoken);
            // setIdCorrida(corridaA);
            getCorrida(corridaA, utoken);
        } else if (data.status === 400) {
            // setIdCorrida('');
        }
    },[getCorrida, getEfiyUti, getEstyCont, intervalo]);

    const getEfiyUtiFecha = async (uToken) => {
        const fechaini = `${new Date(Date.now()).toISOString().slice(0, 11)  }06:00:00.000Z`;
        const fechafin =
            `${new Date(Date.now()).toISOString().slice(0, 11) +
            new Date(Date.now()).toString().slice(16, 24) 
            }.000Z`;
        const data = await fetch(
            `${
                process.env.REACT_APP_SERVICE_ENDPOINT_NE
            }/Informes/GetEfiUtiFechas?celda=${2}&ini=${fechaini}&fin=${fechafin}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${uToken}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values = await data.json();

        if (data.status !== 400) {
            setPorEfi(values.eficiencia);
            setPorUti(values.porcentajeUtilizacion);
            setMtbf(values.mtbf);
            setMttr(values.mttr);
        }
    };

    useEffect(() => {
    const getEnum = async () => {
        const data = await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT_NE}/MicroServiciosController?categoria=EstatusCelda`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );

        const values = await data.json();

        if (data.status !== 400) {
            setEstatus(values);
        }
    };

    getEnum();
}, [tokenSessionObject.token]);

    const intervalRef = useRef(null); 

    useEffect(() => {
        getOrders();
    }, [getOrders]);

    useEffect(() => {
        if (orders.length > 0) {
            getCorridaActiva(tokenR.current);
        }
    }, [getCorridaActiva, orders, tokenR]);

    useEffect(() => {
        clearInterval(interval);
    }, [celda, interval]);

    useEffect(() => {
        if (startCorrida === true) {
            intervalRef.current = setInterval(() => {
                getCorridaActiva(tokenR.current);
            }, 30000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [startCorrida, celda, getCorridaActiva, tokenR]);

    const infoCeldasValues = useMemo(() => {
        return {
            tokenSessionObject,
            meses,
            dias,
            detailOrder,
            detailCorrida,
            status,
            cant,
            startCorrida,
            isCorridaActive,
            mttr,
            mtbf,
            porUti,
            porEfi,
            intervalo,
            setIntervalo,
        };
    }, [
        tokenSessionObject,
        meses,
        dias,
        detailOrder,
        detailCorrida,
        status,
        cant,
        startCorrida,
        isCorridaActive,
        mttr,
        mtbf,
        porUti,
        porEfi,
        intervalo,
        setIntervalo,
    ]);

    return <InfoCeldasContext.Provider value={infoCeldasValues} {...props} />;
}

export function useInfoCeldas() {
    const context = useContext(InfoCeldasContext);
    if (!context) {
        throw new Error('useHome debe estar dentro del proveedor InfoCeldasContext');
    }
    return context;
}
